/**
 * Defines sagas related to view profile dialog box
 */
import { put, call } from 'redux-saga/effects';
import { putUpdateProfileService } from 'services/App.service';
import getCountriesList from 'services/getCountryList.service';
import {
  USER_DETAILS_AFTER_UPDATE,
  UPDATE_PROFILE_DETAILS_ERROR,
  UPDATE_PROFILE_DETAILS_SUCCESS,
  GET_COUNTRIES_LIST_SUCCESS,
  GET_COUNTRIES_LIST_ERROR,
} from 'constants/ActionTypes';

// eslint-disable-next-line import/prefer-default-export
export function* updateProfileDetailsSaga({ requestBody }) {
  try {
    const response = yield call(putUpdateProfileService, requestBody);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    const updatedDetails = {
      firstName: response.json.firstName,
      lastName: response.json.lastName,
      title: response.json.title,
      countryId: response.json.countryId,
      phoneNumber: response.json.phoneNumber,
    };
    yield put({ type: USER_DETAILS_AFTER_UPDATE, updatedDetails });
    yield put({ type: UPDATE_PROFILE_DETAILS_SUCCESS });
  } catch (error) {
    yield put({ type: UPDATE_PROFILE_DETAILS_ERROR, error });
  }
}

/**
 * Saga used to get the country list
 */
export function* getCountriesSaga() {
  try {
    const response = yield call(getCountriesList);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    const countryList = response.json;
    yield put({ type: GET_COUNTRIES_LIST_SUCCESS, countryList });
  } catch (error) {
    yield put({ type: GET_COUNTRIES_LIST_ERROR, error });
  }
}
